module.exports = __webpack_public_path__ + "img/btn-sign-in-fb.4544f590.svg";